import {
  ConflictingJobOrigin,
  ContaminationViolation,
} from '../contaminationViolation';
import { ContaminationRuleJobResponse } from '../contaminationRuleJobResponse';
import { OptimizedTourJob } from '../optimizedTourModel';

export const contaminationViolationNormalizer = (
  violations: ContaminationRuleJobResponse[],
  currentJobId: OptimizedTourJob['jobId'],
  jobIds: OptimizedTourJob['jobId'][]
): ContaminationViolation | null => {
  const violationFromSameTour = violations.find(
    (violation) => violation.offendingJobUid === currentJobId
  );
  let conflictingJobOrigin: ConflictingJobOrigin | undefined;

  if (violationFromSameTour) {
    if (violationFromSameTour.uidOfJobInDatabaseTour) {
      conflictingJobOrigin = 'previousTour';
    } else if (
      jobIds.find((jobId) => jobId === violationFromSameTour.firstJobUid)
    ) {
      conflictingJobOrigin = 'sameTour';
    } else {
      conflictingJobOrigin = 'reviewTour';
    }
  }

  const lastJobFromTourId = jobIds[jobIds.length - 1];
  let violationForNextTour = null;
  // Contamination for the next tour can happen only on the last job
  if (lastJobFromTourId === currentJobId) {
    violationForNextTour = violations.find(
      (violation) => violation.firstJobUid === lastJobFromTourId
    );
  }

  if (violationFromSameTour && conflictingJobOrigin) {
    return {
      conflictingJobId: violationFromSameTour.firstJobUid,
      conflictingJobOrigin,
      isViolatingNextDayTour: Boolean(violationForNextTour),
    };
  }

  if (violationForNextTour) {
    return {
      conflictingJobId: violationForNextTour.firstJobUid,
      conflictingJobOrigin,
      isViolatingNextDayTour: true,
    };
  }

  return null;
};
